<template>
  <div id="tf-area" class="text-center">
    <div class="overlay">
      <div class="section-title center">
        <h2>
          Bodor+<strong>{{ $t("home.area") }}</strong>
        </h2>
        <div class="line">
          <hr />
        </div>
      </div>
      <div id="area" class="owl-carousel owl-theme row">
        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[0]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.machinery") }}
          </p>
        </div>

        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[1]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.advert") }}
          </p>
        </div>

        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[2]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.fitness") }}
          </p>
        </div>

        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[3]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.air") }}
          </p>
        </div>

        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[4]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.architectural") }}
          </p>
        </div>

        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[5]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.car") }}
          </p>
        </div>

        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[6]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.steel") }}
          </p>
        </div>

        <div class="item">
          <div class="imageBox">
            <img :src="imgsUrl[7]" alt="" />
          </div>
          <p class="title" :class="{ titleEn: props.langChange == 'en' }">
            {{ $t("home.ship") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { defineProps } from "vue";
const props = defineProps({
  langChange: String,
});
// const langChange = ref();
// langChange.value = props.langChange;
// console.log(langChange.value);
const imgsUrl = ref([
  require("@/assets/img/area/a1.jpg"),
  require("@/assets/img/area/a2.jpg"),
  require("@/assets/img/area/a3.jpg"),
  require("@/assets/img/area/a4.jpg"),
  require("@/assets/img/area/a5.jpg"),
  require("@/assets/img/area/a6.jpg"),
  require("@/assets/img/area/a7.jpg"),
  require("@/assets/img/area/a8.jpg"),
]);
</script>

<style scoped>
#tf-area {
  background: url("@/assets/img/area.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  color: #ffffff;
}
p {
  margin: 0;
}
.flexBox {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.item {
  box-sizing: border-box;
  color: white;
  text-decoration: none;
}
.item:hover {
  color: #f5a63f;
  text-decoration: none;
  outline: 0;
  cursor: pointer;
}
.item:hover .imageBox::before {
  top: 0px;
}
.imageBox {
  position: relative;
  padding: 0 15px 0 35px;
}
.imageBox::before {
  left: 12px;
  width: 20%;
  content: "";
  position: absolute;
  top: 51px;
  bottom: -30px;
  border: 3px solid #f5a63f;
  border-top: 0;
  border-right: 0;
  transition: 0.33s ease-out;
}
.title {
  margin-top: 12px;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0;
  text-align: center;
}
.titleEn {
  font-size: 12px !important;
}
img {
  width: 100%;
  object-fit: contain;
}
</style>
